import { camelizeKeys } from 'humps';
import { useCallback, useEffect, useState } from 'react';
import { fetchEnd, fetchStart } from 'react-admin';
import { useDispatch } from 'react-redux';
import { fetchApi } from '../utils/api';

export const useGetUserTags = (userId) => {
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState(null);

  const dispatch = useDispatch();

  const getTags = useCallback(() => {
    dispatch(fetchStart());
    setLoading(true);
    fetchApi(`/users/${userId}/tags`, {
      method: 'GET',
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          return Promise.reject(response);
        }
      })
      .then((data) => {
        setTags(camelizeKeys(data));
      })
      .catch((error) => {
        if (typeof error.json === 'function') {
          error.json().then((error) => {
            console.log(error);
          });
        } else {
          console.log(error);
        }
      })
      .finally(() => {
        setLoading(false);
        dispatch(fetchEnd());
      });
  }, [dispatch, userId]);

  useEffect(() => {
    if (!tags) {
      getTags();
    }
  }, [getTags, tags]);

  return {
    loading,
    getTags,
    tags,
    setTags,
  };
};
